import { render, staticRenderFns } from "./QuizWorkspace.vue?vue&type=template&id=86eed4f2&scoped=true"
import script from "./QuizWorkspace.vue?vue&type=script&lang=ts"
export * from "./QuizWorkspace.vue?vue&type=script&lang=ts"
import style0 from "./QuizWorkspace.vue?vue&type=style&index=0&id=86eed4f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86eed4f2",
  null
  
)

export default component.exports